import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../Components/Button';
import { LanguageContext } from '../Components/LanguageContext';
import handleTransformLang from '../functions/handleTransformLang';
import Layout from '../Layout';
import supportRepairTrackingPage from '../lang/pages/supportRepairTracking.json';

const INPUT_CLASS =
  'block h-[3.85rem] w-full border border-[#b7beca] bg-white px-6 text-[17px] text-text_secondary transition focus:outline-none focus:ring-2 focus:ring-text_primary placeholder:text-[#95a0b1]';

export default function SupportRepairTracking() {
  return (
    <Layout headData={supportRepairTrackingPage.head}>
      <InnerPage />
    </Layout>
  );
}

function InnerPage() {
  const { language } = useContext(LanguageContext);
  const [pageContent, setPageContent] = useState(
    handleTransformLang(supportRepairTrackingPage)
  );

  useEffect(() => {
    setPageContent(handleTransformLang(supportRepairTrackingPage));
  }, [language]);

  return (
    <section className="bg-white pb-28 pt-10 lg:pb-32 lg:pt-12">
      <div className="container mx-auto max-w-8xl px-4">
        <div className="flex items-start justify-between gap-8">
          <Link to="/" className="inline-flex">
            <img
              src="/images/logo.svg"
              alt="Bulutmarket"
              className="h-24 w-auto lg:h-28"
            />
          </Link>

          <div className="hidden flex-col gap-7 pt-3 lg:flex">
            {pageContent.forms.map((item) => (
              <a
                key={item.label}
                href={item.href}
                download={item.download}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-3 text-left"
              >
                <img
                  src="/images/support/ic_sayfa_formlar_icon.svg"
                  alt=""
                  className="h-[3.4rem] w-auto shrink-0"
                />
                <span
                  className="text-[17px] font-semibold text-[#6a7487] transition-colors duration-200 group-hover:text-bg_primary"
                >
                  {item.label}
                </span>
              </a>
            ))}
          </div>
        </div>

        <div className="mx-auto mt-24 max-w-[74rem] text-center lg:mt-32">
          <h1 className="text-[32px] font-bold leading-tight text-text_primary">
            {pageContent.title}
          </h1>

          <p className="mx-auto mt-8 max-w-[66rem] text-[17px] leading-[1.75] text-text_secondary">
            {pageContent.description}
          </p>

          <div className="mx-auto mt-24 max-w-[65.25rem]">
            <input
              type="text"
              maxLength={100}
              placeholder={pageContent.placeholder}
              className={INPUT_CLASS}
            />
          </div>

          <div className="mt-20 flex justify-end">
            <Button type="button" size="lg" className="min-w-[10.5rem]">
              {pageContent.buttonLabel}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
